import FormGroup from '~/components/form/FormGroup';
import { FormHorizontal } from '~/components/form/layout';
import { useTz } from '~/components/hooks/useTz';
import { InputCardOption } from '~/components/input/InputCards';
import ZodFieldDate from '~/components/zod/ZodFieldDate';
import ZodFieldCards from '~/components/zod/ZodFieldCards';
import { capitalize } from '~/lib/format';
import { BreOrderContext } from '~/tenants/bre/model/BreOrderContext';
import { layoutSchema } from '~/tenants/bre/performable/print/design/BreDesignConfig';
import { BreDesignRate } from '~/tenants/bre/performable/print/design/BreDesignData';
import { countSchema } from '~/tenants/bre/performable/print/postcards/printonly/BrePostcardsPrintOnlyConfig';
import { BrePostcardsPrintOnlyRate } from '~/tenants/bre/performable/print/postcards/printonly/BrePostcardsPrintOnlyData';
import { TenantPerformableFormProps } from '~/tenants/common/form';
import { TenantPackageAddOnCards } from '~/tenants/common/package';
import { TenantPerformableAddOns } from '~/tenants/common/performable';
import { ReactElement } from 'react';
import { isBusinessDay, plusBusinessDays } from '~/tenants/bre/performable/common';

const COUNT_OPTS = countSchema.options.map<InputCardOption>((value) => ({
  title: `${value} Pieces`,
  cost: BrePostcardsPrintOnlyRate[value],
  value,
}));

export default function BrePostcardsPrintOnlyForm(props: TenantPerformableFormProps<BreOrderContext>): ReactElement {
  const { persona } = props;

  const tz = useTz();

  const designOptions = layoutSchema.options.map<InputCardOption>((value) => {
    const rate = BreDesignRate[value].postcard_half;

    return {
      title: `${capitalize(value)} Layout`,
      cost: rate,
      disabled: !rate,
      value,
    };
  });

  return (
    <FormGroup>
      <FormHorizontal name="count" label="Count" required>
        <ZodFieldCards name="count" options={COUNT_OPTS} required />
      </FormHorizontal>
      <FormHorizontal name="need_by" label="Need by" required>
        <ZodFieldDate
          name="need_by"
          filter={(date) => isBusinessDay(date) && date >= plusBusinessDays(tz().startOf('day'), 1)}
        />
      </FormHorizontal>

      <TenantPerformableAddOns persona={persona}>
        <TenantPackageAddOnCards
          name="design"
          title="Graphic Design only"
          description="Include layout design to your flyers"
          image="tenant/bre/print/design.jpg"
          persona={persona}
          options={designOptions}
          cols={2}
          required
        />
      </TenantPerformableAddOns>
    </FormGroup>
  );
}
